class AnalyticsService {
    constructor() {
        this.config = window.__mt;
    }

    //event Search
    search(data) {
        const payload = {
            event: 'search',
            origin_type: this.normalizeSlug(data.arrival_type),
            destiny_type: this.normalizeSlug(data.departure_type),
            pickup_date: this.formatDate(data.arrival_date),
            passengers: parseInt(data.adults || 0) + parseInt(data.children || 0) + parseInt(data.infants || 0),
            trip: this.normalizeSlug(data.transfer_type)
        }
        if(data.transfer_type === 'roundtrip' && data.departure_date) {
            payload['return_date'] = this.formatDate(data.departure_date);
        }

        this.pushDatalayer(payload);
    }

    viewItemList(response, box) {
        let transferList = response.transferPriceList;
        let items = [];
        let box_base = this.getBaseBox(box);
        for (let index = 0; index < transferList.length; index++) {
            const element = transferList[index];
            const base = this.getBaseTransfer(element, index + 1);
            items.push(base);
        }
        
        let payload = {
            event: "view_item_list",
            origin_type: this.normalizeSlug(box_base.arrival_type), // tipo de origen: airport, address, station, port
            destiny_type: this.normalizeSlug(box_base.departure_type), // tipo de destino: airport, address, station, port
            pickup_date: this.formatDate(box_base.arrival_date),
            passengers: parseInt(box_base.total_pax), // número de pasajeros de la búsqueda
            trip: box_base.trip, // round trip o one way
            ecommerce:
            {
                currency: 'EUR',
                items: items
            }
        };

        if(box_base.trip === 'roundtrip' && box_base.departure_date) {
            payload['return_date'] = this.formatDate(box_base.departure_date);
        }

        this.pushDatalayer(payload);
    }

    formatDate(dateString) {
        if (!dateString) return '';
        const [date] = dateString.split(' ');
        const [year, month, day] = date.split('-');
        return `${day}${month}${year}`;
    }

    normalizeSlug(text) {
        if (!text) return '';
        return text
            .toString()
            .toLowerCase()
            .trim()
            .replace(/\s+/g, '-')
            .replace(/[^\w\-]+/g, '')
            .replace(/\-\-+/g, '-')
            .replace(/^-+/, '')
            .replace(/-+$/, '');
    }

    getBaseTransfer(transport, index) {
        var category = this.normalizeSlug(transport.transportName.split(" ")[1] || '');
        return {
            item_id: transport.transportId,
            item_name: this.normalizeSlug(transport.transportName),
            price: transport.price,
            item_variant: transport.maxPassengers,
            index: + index,
            quantity: 1,
            item_type: "vehiculo",
            item_category: category
        }
    }

    getBaseBox(box) {
        let params = {};

        params.adults = + box.adults;
        params.children = + box.children;
        params.infants = + box.infants;
        params.total_pax = params.adults + params.children + params.infants;

        params.arrival_date = box.arrival_date;
        params.arrival_type = box.arrival_type;
        params.departure_date = box.departure_date;
        params.departure_type = box.departure_type;

        params.arrival_datetime = this.config.fn.getDate(box.arrival_date);
        params.departure_datetime = this.config.fn.getDate(box.departure_date);
        params.current_date = this.config.fn.getDate();
        params.advance_booking = Math.abs(Math.round(((params.arrival_datetime - params.current_date) / 36e5)));

        params.origin = this.normalizeSlug(box.from);
        params.destiny = this.normalizeSlug(box.to);
        params.trip = box.transfer_type;

        return params;
    }

    pushDatalayer(data) {
        if (window.dataLayer) {
            window.dataLayer.push(data);
        }
    }
}

export const analyticsService = new AnalyticsService();